import { render } from "./DateStamp.vue?vue&type=template&id=2a9bde76&scoped=true"
import script from "./DateStamp.vue?vue&type=script&lang=js"
export * from "./DateStamp.vue?vue&type=script&lang=js"

import "./DateStamp.vue?vue&type=style&index=0&id=2a9bde76&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9bde76"]])

export default __exports__